import { Components, Theme } from "@mui/material/styles"

export const muiTooltip = (): Components<
  Omit<Theme, "components">
>["MuiTooltip"] => {
  return {
    styleOverrides: {
      tooltip: ({ theme }) => ({
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "4px",
        boxShadow: `0px 2px 4px 0px ${theme.palette.divider}`,
        color: theme.palette.text.secondary,
        margin: 0,
        marginTop: 0.5,
        padding: "0.5rem",

        // Copy font styling from overline
        fontSize: theme.typography.overline.fontSize,
        fontWeight: theme.typography.overline.fontWeight,
        lineHeight: theme.typography.overline.lineHeight,
      }),
    },
  }
}
